const layout = {
  sideBar: {
    menu: {
      more: {
        children: {
          shifts: 'Schulzeiten',
        },
      },
    },
  },
};

export default layout;
